// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "stripe-ui .stripe-ui{border-style:none;padding:0}stripe-ui .stripe-ui .stripe-ui-header .stripe-ui-logos,stripe-ui .stripe-ui .stripe-ui-header p{display:none}stripe-ui .stripe-ui .stripe-ui-header .stripe-ui-logos svg{margin-left:0;margin-right:2rem}stripe-hosted-fields{margin-top:1.5rem;width:100%}.payment-stripe-container #submit{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
